import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EksisPage } from './eksis.page';
import { BuatPostingPage } from '../buat-posting/buat-posting.page';
const routes: Routes = [
  {
    path: '',
    component: EksisPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EksisPage]  
})
export class EksisPageModule {}
